import './Button.css';import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import IcoSpinner from "../../../assets/IconSpinner.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { useMemo, useCallback } from "react";
/* empty css           */
import throttle from "../../../external/lodash-es/throttle.js";
const Button = ({
  classes,
  className,
  children,
  variant = "primary",
  size = "md",
  icon,
  iconPosition = "left",
  loading = false,
  disabledOnLoading = true,
  ignorePointerEventsOnLoading = true,
  loader,
  throttleIn,
  onClick,
  shiny,
  ["aria-label"]: ariaLabel,
  ...btnProps
}) => {
  const { themeClasses } = useThemePresetClasses("Button", classes, className, {
    variant,
    modifier: size
  });
  const isDisabled = useMemo(() => {
    if (disabledOnLoading) {
      return loading || btnProps.disabled;
    } else {
      return btnProps.disabled;
    }
  }, [btnProps.disabled, disabledOnLoading, loading]);
  const throttleOnClick = useCallback(() => {
    if (onClick && !isDisabled) {
      if (throttleIn) {
        return throttle(onClick, throttleIn);
      }
      return onClick;
    }
  }, [onClick, isDisabled, throttleIn]);
  const RawButton = useMemo(
    () => /* @__PURE__ */ jsx(
      "button",
      {
        className: cn(themeClasses == null ? void 0 : themeClasses.root, {
          "pointer-events-none": ignorePointerEventsOnLoading && loading
        }),
        ...btnProps,
        disabled: isDisabled,
        onClick: throttleOnClick(),
        "aria-label": ariaLabel,
        children: /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(themeClasses == null ? void 0 : themeClasses.label),
            "aria-label": ariaLabel,
            children: loading ? !!loader ? loader : /* @__PURE__ */ jsx(IcoSpinner, { className: cn(themeClasses == null ? void 0 : themeClasses.spinner) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
              icon && iconPosition === "left" && icon,
              children,
              icon && iconPosition === "right" && icon
            ] })
          }
        )
      }
    ),
    [
      btnProps,
      children,
      icon,
      iconPosition,
      ignorePointerEventsOnLoading,
      isDisabled,
      loader,
      loading,
      themeClasses == null ? void 0 : themeClasses.label,
      themeClasses == null ? void 0 : themeClasses.root,
      themeClasses == null ? void 0 : themeClasses.spinner,
      throttleOnClick,
      ariaLabel
    ]
  );
  if (shiny) {
    return /* @__PURE__ */ jsxs("div", { className: cn("relative", themeClasses == null ? void 0 : themeClasses.shinyWrapper), children: [
      /* @__PURE__ */ jsx("span", { className: cn("ui-sdk__button--shiny absolute opacity-90", themeClasses == null ? void 0 : themeClasses.shiny) }),
      RawButton
    ] });
  }
  return RawButton;
};
const Button$1 = Button;
export {
  Button$1 as default
};
